/* #1 商品数の横に「何で絞り込まれているか」を表示（Issue#107）
   テーマ独自の「現在の絞り込み条件」(.kido-selected__tags)の文言を、商品数(.boost-pfs-filter-total-product)の横に複製。
   Boost内部は触らず、DOMを監視して同期するだけ（安全）。 */
(function(){
  "use strict";
  var ID = 'kido-filter-summary';

  function selectedLines(){
    var out = [];
    document.querySelectorAll('.kido-selected__tags li').forEach(function(li){
      var t = (li.textContent||'').replace(/\s+/g,' ').trim();
      if (t) out.push(t);
    });
    return out;   // 各ジャンル（国産／広葉樹／木の種類／サイズ 等）を1要素ずつ
  }

  function anchor(){
    // 商品グリッドの直前＝ツールバー(商品数)の下・全幅。モーダル/ドロワー内は除外。
    var grids = document.querySelectorAll('.boost-pfs-filter-products');
    for (var i=0;i<grids.length;i++){
      var g = grids[i];
      if (g.closest('.boost-pfs-filter-tree-mobile, [class*="drawer"]')) continue;
      return g;
    }
    return null;
  }
  function sync(){
    var existing = document.getElementById(ID);
    // PC（幅768px以上）では表示しない＝スマホのみ表示
    if (window.innerWidth >= 768){ if (existing) existing.remove(); return; }
    var lines = selectedLines();
    if (lines.length){
      var a = anchor();
      if (!a || !a.parentNode) return;
      if (!existing){
        existing = document.createElement('div');
        existing.id = ID;
        // 「現在の絞り込み条件」(kido-selected)と同じ#f2f2f2の帯・全幅。
        existing.setAttribute('style',
          'display:block;box-sizing:border-box;width:100%;margin:0 0 10px;'+
          'padding:8px 14px;background:#f2f2f2;border-radius:2px;'+
          'font-family:\'Hiragino Kaku Gothic ProN\',\'Yu Gothic\',sans-serif;'+
          'font-size:12px;color:#333;line-height:1.7;');
      }
      // 各ジャンルを改行（1行1ジャンル）
      var key = lines.join('\n');
      if (existing.getAttribute('data-k') !== key){
        existing.innerHTML = '';
        lines.forEach(function(l){
          var row = document.createElement('div');
          row.textContent = l;
          existing.appendChild(row);
        });
        existing.setAttribute('data-k', key);
      }
      // 帯の直後が商品グリッド、または欅訴求(その下に商品グリッド)なら正常＝動かさない。欅訴求を飛び越えて下に回り込まない。
      var nx = existing.nextElementSibling;
      if (nx !== a && !(nx && nx.id === 'kido-keyaki-filter-msg')){ a.parentNode.insertBefore(existing, a); }
    } else if (existing){
      existing.remove();
    }
  }

  function boot(){
    sync();
    var target = document.querySelector('.boost-pfs-filter-options-wrapper') || document.body;
    try { new MutationObserver(function(){ sync(); }).observe(target, {childList:true, subtree:true, characterData:true}); } catch(_){}
    // ツールバー再描画にも追従
    document.addEventListener('click', function(e){ if(e.target && e.target.closest && e.target.closest('[class*="boost-pfs-filter"]')) setTimeout(sync, 500); }, true);
    window.addEventListener('popstate', function(){ setTimeout(sync, 500); });
    window.addEventListener('resize', function(){ sync(); });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(boot, 800); });
  else setTimeout(boot, 800);
})();
